import zh from '@/internationalization/trans/chefs/zh/zh.json';
export default {
  trans: zh,
};
